<script setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

defineProps({
  items: Array,
})
</script>

<template>
  <div v-for="item, idx in items" class="item-list-item" :key="`item-${idx}`">
    <span>{{ item.name }}<span v-if="item.new" class="new-item">NEW</span></span>
    <div class="trash-icon" @click="item.removeFn"><FontAwesomeIcon icon="fa-solid fa-trash" /></div>
  </div>
</template>

<style>
.item-list-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  max-width: 25em;

  .new-item {
    margin-left: 1em;
    padding: 0.3em;
    font-size: 0.7em;
    color: white;
    background-color: var(--halsa-green);
    border-radius: 9999px;
  }

  .trash-icon {
    color: var(--halsa-red);
    cursor: pointer;
  }
}
</style>